export const BOT_HANDOFF = 'BOT_HANDOFF';
export const MANUAL = 'MANUAL';
export const MULTIPLE = 'MULTIPLE';
export const VISITOR = 'VISITOR';
export const SYSTEM_AUTOMATIC = 'SYSTEM_AUTOMATIC';
export const SYSTEM_MIGRATION = 'SYSTEM_MIGRATION';
export const SYSTEM_TEST = 'SYSTEM_TEST';
export const UNKNOWN = 'UNKNOWN';